"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _web3Utils = require("web3-utils");

var _FDSMultibox = _interopRequireDefault(require("./FDS-Multibox.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

class Mailbox {
  constructor(config) {
    this.config = config;
    this.web3 = this.config.web3;
  }
  /**
   * encode feed locatio hash
   * @param {any} senderAddress address
   * @param {any} recipientNamehash recepient hash
   * @returns {any} encoded sender and recipient hash
   */


  encodeFeedLocationHash(senderAddress, recipientNamehash) {
    return senderAddress + recipientNamehash.substr(42, 66);
  }
  /**
   * subdomain name hash to feed location hash
   * @param {any} recipientNamehash hash of recipient name
   * @returns {any} substring of recepient name hash that is feed location hash
   */


  subdomainNameHashToFeedLocationHash(recipientNamehash) {
    return recipientNamehash.substr(42, 66);
  }
  /**
   * Decode feed location
   * @param {any} feedLocationHash hash of feed location
   * @returns {any} object with address and topic
   */


  decodeFeedLocationHash(feedLocationHash) {
    return {
      address: feedLocationHash.substring(0, 42),
      topic: feedLocationHash.substr(42, 66)
    };
  } // async newInboxFeed(account, recipientSubdomain, multiboxAddress, feedLocationHash, applicationDomain = 'shared') {
  //     let multibox = await new Multibox(account, this.config).at(multiboxAddress);
  //     return multibox.set(`/shared/mail/$(applicationDomain)/$(senderAccount.subdomain)`, feedLocationHash);
  // }
  // async getInboxFeed(account, subdomain, multiboxAddress, applicationDomain = 'shared'){
  //     let multibox = await new Multibox(account, this.config).at(multiboxAddress);
  //     return multibox.get(`/shared/mail/$(applicationDomain)/$(subdomain)`);
  // }


  newInboxFeed(senderAccount, subdomain, senderSubdomainNamehash, multiboxAddress, feedLocationHash, multiboxPath) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var multibox = yield new _FDSMultibox.default(senderAccount, _this.config).at(multiboxAddress);
      return multibox.set(multiboxPath, senderSubdomainNamehash, feedLocationHash);
    })();
  }

  getInboxFeed(senderAccount, subdomain, multiboxAddress, path) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var multibox = yield new _FDSMultibox.default(senderAccount, _this2.config).at(multiboxAddress);
      return multibox.get(path);
    })();
  }

  getInboxFeeds(account, multiboxAddress, path) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      var multibox = yield new _FDSMultibox.default(account, _this3.config).at(multiboxAddress);
      return multibox.get(path);
    })();
  }

}

var _default = Mailbox;
exports.default = _default;
module.exports = exports.default;